import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var ValuesPipe = (function () {
    function ValuesPipe() {
    }
    ValuesPipe.prototype.transform = function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).map(function (k) { return obj[k]; });
    };
    ValuesPipe.decorators = [
        { type: Pipe, args: [{ name: 'values' },] },
    ];
    /** @nocollapse */
    ValuesPipe.ctorParameters = function () { return []; };
    return ValuesPipe;
}());
export { ValuesPipe };
//# sourceMappingURL=values.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/values.js
// module id = 276
// module chunks = 4